module.exports = __webpack_public_path__ + "img/018.036820bd.png";